module.exports = __webpack_public_path__ + "static/media/avntMobile2.d75b7bef.png";